import React from 'react';
import moment from 'moment';
import Table from './table';

class Component extends React.Component {
  state = {
    text: '',
    result: [],
    result2: [],
    items: [],
    duplicates: 0,
    offer: 'andy',
    duplicateItems: []
  };

  componentWillMount() {
    this.setState({
      text: this.props.state.text || ''
    });
  }

  parse = () => {
    clearTimeout(this.timeout);
    this.makeItems();
    let rows = this.state.text.split('\n');
    let result = [];
    let hash = {};
    rows.map((row) => {
      try {
        var row2 = row.replace(/\t/g, ' ').replace(/  /g, ' ').trim();
        var split0 = row2.split('cashplane');
        var isAndy = this.state.offer === 'andy';
        if (isAndy) {
          split0 = row2.split(' ');
        }
        if (split0.length < 2) return;
        var split = split0[split0.length - 1].trim().split(' ');
        var lastChunk = split[split.length - 1];
        // console.log({row,lastChunk,split0,split})
        var wid = parseInt(lastChunk.split('-')[0].trim());
        // if (!(wid > 0)) console.log(wid,split)
        if (!(wid > 0) && split.length > 1)
          wid = parseInt(split[split.length - 2].split('-')[0].trim());
        if (isAndy) {
          wid = parseInt(split0[1].split('_')[0]);
        }
        if (wid && wid > 0) {
          if (!hash[wid]) hash[wid] = 0;
          hash[wid]++;
        } else {
          console.log('!wid', wid, lastChunk.split('-')[0].trim());
        }
      } catch (err) {
        console.log(err, row);
      }
    });
    for (let wid in hash) {
      result.push({
        wid,
        frauds: hash[wid]
      });
    }
    this.setState({ result });
    let equal = JSON.stringify(this.state.result) == JSON.stringify(this.state.result2);
    console.log({ equal });
  };

  // click_date_time agent_id  ip_address  session_id  office_id
  // 2023-04-30T06:00:07+00:00 205553  2606:b300:9600::152 20887546  204940
  parseDanny = (row) => {
    let split = row.split(' ');
    if (split.length === 4) split.splice(1, 0, '');
    let [date, subaffiliate, ip, clickId, wid] = split;
    if (!(wid && parseInt(wid) > 0)) {
      console.log('!affiliate', row);
      return;
    }
    return {
      date: new Date(date).getTime(),
      name1: 'easysex',
      name2: clickId,
      wid,
      subaffiliate,
      offer: 'easysex'
    };
    return item;
  };

  // CPCT  10136_10148 04/27/21 00:42  big81137hzh 5644  roxanne21@gmail.com 139.99.159.20
  parseAndy = (row) => {
    let rowSplit = row.split(' ');
    var [accName, affiliate, date, time, username, pwd, email, ip] = rowSplit;
    var dateFormat = 'MM/DD/YY hh:mm';
    if (!affiliate) {
      console.log('!affiliate', row);
      return;
    }
    let affSplit = affiliate.split('-');
    let wid = parseInt(affSplit[0]);
    if (!(wid > 0)) {
      console.log('!affiliate', row);
      return;
    }
    let item = {
      date: moment(date + ' ' + time, dateFormat).valueOf(),
      name1: accName,
      name2: username + '__' + email,
      wid,
      subaffiliate: affSplit.length > 1 ? affSplit[1] : '',
      offer: 'andy'
    };
    return item;
  };

  parseHugo = (row) => {
    let rowSplit = row.split(' ');
    var [date, time, name1, name2, affiliate] = rowSplit;
    var dateFormat = 'M-D-YYYY H:mm';
    let affOk = affiliate && parseInt(affiliate.split('-')[0]) > 0;
    if (!affOk && name1 && name1.indexOf('cashplane') == 0) {
      [date, time, name2, affiliate] = row.split(' ');
      name1 = '-';
    }
    if (!affiliate) {
      console.log('!affiliate', { date, time, name1, name2, affiliate, row });
      return;
    }
    let affSplit = affiliate.split('-');
    let wid = parseInt(affSplit[0]);
    if (!(wid > 0)) {
      console.log('!affiliate', { date, time, name1, name2, affiliate, row });
      return;
    }
    let item = {
      date: moment(date + ' ' + time, dateFormat).valueOf(),
      originalDate: date + ' ' + time,
      name1,
      name2,
      wid,
      subaffiliate: affSplit.length > 1 ? affSplit[1] : '',
      offer: 'chatsales'
    };
    return item;
  };

  parseRow = (row) => {
    let row2 = row
      .replace(/\t/g, ' ')
      .replace(/                   /g, ' ')
      .replace(/                  /g, ' ')
      .replace(/                 /g, ' ')
      .replace(/                /g, ' ')
      .replace(/               /g, ' ')
      .replace(/              /g, ' ')
      .replace(/             /g, ' ')
      .replace(/            /g, ' ')
      .replace(/           /g, ' ')
      .replace(/          /g, ' ')
      .replace(/         /g, ' ')
      .replace(/        /g, ' ')
      .replace(/       /g, ' ')
      .replace(/      /g, ' ')
      .replace(/     /g, ' ')
      .replace(/    /g, ' ')
      .replace(/   /g, ' ')
      .replace(/  /g, ' ')
      .trim();
    if (!row2) return;
    var item;
    switch (this.state.offer) {
      case 'andy':
        item = this.parseAndy(row2);
        break;
      case 'chatsales':
        item = this.parseHugo(row2);
        break;
      case 'danny':
        item = this.parseDanny(row2);
        break;
    }
    if (!item) return;
    item.id = [item.date, item.name1, item.name2, item.wid, item.subaffiliate].join('|');
    return item;
  };

  makeItems = () => {
    clearTimeout(this.timeout);
    let rows = this.state.text.split('\n');
    let items = [];
    let hash = {};
    let itemsHash = {};
    let result = [];
    let duplicates = 0;
    let duplicateItems = [];
    rows.map((row) => {
      try {
        let item = this.parseRow(row);
        if (!item) return;
        let { wid } = item;
        if (!itemsHash[item.id]) {
          itemsHash[item.id] = item;
          items.push(item);
          if (!hash[wid]) hash[wid] = 0;
          hash[wid]++;
        } else {
          duplicates++;
          console.log('duplicate:', row);
          duplicateItems.push(row);
        }
      } catch (err) {
        console.log(err);
      }
    });
    for (let wid in hash) {
      result.push({
        wid,
        frauds: hash[wid]
      });
    }
    this.setState({ result2: result, items, duplicates, duplicateItems });
  };

  onChange = (e) => {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(this.parse, 10);
    this.props.setState({ text: e.target.value });
    this.setState({ text: e.target.value }, this.parse);
  };

  onBlur = (e) => {
    this.parse();
  };

  save = (e) => {
    e && e.preventDefault();
    let items = this.state.items;
    if (items.length == 0 || this.props.loading) return;
    this.props.api('fraud/save', { items, offer: this.state.offer }).then(() => {
      console.log(this.table, this.table.getWrappedInstance());
      this.table.getWrappedInstance().fetchData({ forceReload: true });
    });
  };

  clear = (e) => {
    e && e.preventDefault();
    if (confirm('Clear all records?')) {
      this.props.api('fraud/clear', {}).then(() => {
        location.reload();
      });
    }
  };

  setOffer = (offer) => {
    this.setState({ offer }, this.parse);
  };

  render() {
    let { result, result2, items, duplicates, offer, duplicateItems } = this.state;
    let { props } = this;
    // console.log('render', items.length);
    return (
      <div>
        {result2.length > 0 && (
          <table class='table table-bordered table-striped table-sm'>
            <thead>
              <tr class='white'>
                <th>Wid</th>
                <th>Flagged sales</th>
              </tr>
            </thead>
            <tbody>
              {result2.map((item) => (
                <tr key={item.wid}>
                  <td>{item.wid}</td>
                  <td>{item.frauds}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {duplicateItems && duplicateItems.length > 0 && (
          <div>
            Duplicated:
            {duplicateItems.map((item, index) => (
              <div key={index}>{item}</div>
            ))}
          </div>
        )}
        <div>
          <div class='text-center mb-3'>
            <div class='btn-group text-center'>
              <button
                type='button'
                class={'btn btn-sm primary ' + (offer === 'andy' ? 'active' : '')}
                onClick={() => this.setOffer('andy')}
              >
                Andy
              </button>
              <button
                type='button'
                class={'btn btn-sm primary ' + (offer === 'chatsales' ? 'active' : '')}
                onClick={() => this.setOffer('chatsales')}
              >
                Hugo
              </button>
              <button
                type='button'
                class={'btn btn-sm primary ' + (offer === 'danny' ? 'active' : '')}
                onClick={() => this.setOffer('danny')}
              >
                Danny
              </button>
            </div>
          </div>

          <textarea
            class='form-control col-12'
            rows='20'
            cols='50'
            value={this.state.text}
            onChange={this.onChange}
            onBlur={this.onBlur}
          />
        </div>
        <div>duplicates: {duplicates}</div>
        {items.length == 0 && (
          <div class='p-3 text-right w-100'>
            <button class='btn btn-danger' onClick={this.clear}>
              Clear database
            </button>
          </div>
        )}
        {items.length > 0 && (
          <div>
            <div class='p-3 mt-4'>
              <div class='pull-right'>
                <button class='btn btn-danger' onClick={this.clear}>
                  Clear database
                </button>
              </div>
              <div>
                {!props.loading && (
                  <button class='btn' onClick={this.save}>
                    Save
                  </button>
                )}
                {props.loading && <div>Saving...</div>}
                {!props.loading && !props.initial && <div>Saved: {props.saved}</div>}
                {props.error && <div>Error</div>}
              </div>
            </div>
            <table class='table table-bordered table-striped table-sm mt-5'>
              <thead>
                <tr class='white'>
                  <th>№</th>
                  <th>Id</th>
                  <th>Date</th>
                  <th>Name1</th>
                  <th>Name2</th>
                  <th>Wid</th>
                  <th>Subaffiliate</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, i) => (
                  <tr key={item.id}>
                    <td>{i + 1}</td>
                    <td>{item.id}</td>
                    <td>{moment(item.date).format('DD MMM YYYY, HH:mm')}</td>
                    <td>{item.name1}</td>
                    <td>{item.name2}</td>
                    <td>{item.wid}</td>
                    <td>{item.subaffiliate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div class='mt-5'>
          <Table ref={(ref) => (this.table = ref)} />
        </div>
      </div>
    );
  }
}

import api from 'src/actions/api';
import setState from 'src/actions/state';
import { connect } from 'react-redux';

export default connect(
  function (state) {
    let apiState = state.api.fraud_save || state.api.initial;
    return {
      ...apiState.data,
      initial: apiState.initial,
      loading: apiState.loading,
      error: apiState.error,
      // saved: !apiState.initial && !apiState.loading && !apiState.error,
      saved: (apiState.data && apiState.data.saved) || 0,
      state: state.state.fraud_sales || state.state.initial,
      user: state.session.user
    };
  },
  {
    api,
    setState: setState('fraud_sales')
  }
)(Component);
